import {
	AutodeskContext,
	AutodeskTeams,
	AutodeskUserProfile,
	Team,
} from './forge';
import { UserProject } from './project.types';
import { InnovyzeRole } from '../utils/InnovyzeRole';
import { Terms } from './terms.types';

interface EmulatorUser {
	name: string;
	email: string;
	id?: string;
}

export interface UserContext {
	defaultSite: string;
	defaultSiteProjectId: string;
	defaultTeamId: string;
	innovyzeRole: InnovyzeRole;
	id: string;
	email: string;
	name: string;
	entitlements: string[];
	termsAndConditions: Terms & {
		status: 'idle' | 'loading' | 'resolved' | 'rejected';
	};
	inEmulation?: boolean;
	emulatorUser?: EmulatorUser;
	subscriptions?: Record<string, string[]>;
	currentTeamLicenses?: CLSLicense[];
	otherTeamLicenses?: CLSLicense[];
	productAccessLevels: string[];
	loading?: boolean;
}

export type CLSLicense = {
	reauthz: number;
	id: string;
	ceid: string;
	o2id: string;
	fid: string;
	exp: number;
	auth: boolean;
	iat: number;
	iss: string;
	lattr: number;
	lattrmsk: number;
};
export interface LicenseAttributes {
	fid: string;
	trial: boolean; //  0x01
	temp: boolean; //  0x02
	gracePeriod: boolean; //  0x08
	missingEntitlement: boolean; //  0x10
	expiringEntitlement: boolean; //  0x20
	expiredEntitlement: boolean; //  0x40
	hobbyist: boolean; //  0x80
	student: boolean; // 0x100
	enthusiastOrStartup: boolean; // 0x200
	isAllTruthy: boolean;
}

export interface ProcessUserContextParams {
	autodeskUserContext: AutodeskContext | null;
	userProfile: AutodeskUserProfile;
	accessToken: string;
}

export interface StoreUserContextParams {
	userProfile: AutodeskUserProfile;
	userContext: Partial<UserContext>;
	defaultSite: string;
	defaultSiteProjectId: string;
	defaultTeamId: string;
	entitlements: string[];
	accessToken: string;
}

export interface UserContextStoreState {
	userContext: UserContext;
}
